import type { ReactNode } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

/** Shown when a new build has been installed in the background and is waiting. */
export function UpdatePrompt(): ReactNode {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="toast-stack">
      <div className="toast update-toast" role="status">
        <span>Update available — reload</span>
        <button className="btn primary" onClick={() => void updateServiceWorker(true)}>
          Reload
        </button>
        <button className="btn" onClick={() => setNeedRefresh(false)}>
          Later
        </button>
      </div>
    </div>
  );
}
